import React, { useEffect } from "react";
import Categories from "../components/categories/Categories";
import FastDeliveryCard from "../components/fastDeliveryCard/FastDeliveryCard";
import LatestDiscountCouponCode from "../components/latestDiscountCouponCode/LatestDiscountCouponCode";
import PopularProduct from "../components/popularProduct/PopularProduct";
import OrganicProductCard from "../components/organicProductCard/OrganicProductCard.js";
import Slider from "../components/slider/Slider";
import LatestDiscountedProduct from "../components/latestDiscountedProduct/LatestDiscountedProduct";
import Cart from "../components/cart/Cart";
import { useFetchAllOffersQuery } from "../store/api/ProductSlice.js";
import SEO from "./SEO.js";
import AnnouncementPopup from "./AnnouncementPopup.js";
import Header1 from "./Homepage/Header1.js";
import ShopByCategory from "./Homepage/ShopByCategory.js";
import FeaturedBrands from "./Homepage/FeaturedBrands.js";
import CuratedCollections from "./Homepage/CuratedCollections.js";
import Footer from "./Homepage/Footer.js";
import PufframaBanner from "./Homepage/PufframaBanner.js";

function Home() {
  const {
    data,
    error,
    isLoading,
  } = useFetchAllOffersQuery();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gray-50">
      {/* <AnnouncementPopup /> */}

      <SEO
        title="Buy Nicotine Products Online | Fast Delivery & Trusted Brands – Pufframa"
        description="Shop nicotine pouches, gums, and oral products online at Pufframa. Fast delivery, discreet packaging, top brands, and a wide range of strengths and flavors. Adults 18+ only."
        image="https://pufframa.com/static/media/logo.44eaa8fdaa825d84dd29.png"
        url="https://pufframa.com/"
        keywords="uy nicotine online, nicotine pouches, nicotine gum, oral nicotine, nicotine products India, discreet nicotine delivery,pufframa"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Pufframa",
          url: "https://pufframa.com/",
          potentialAction: {
            "@type": "SearchAction",
            target:
              "https://pufframa.com/search?q={search_term_string}",
            "query-input":
              "required name=search_term_string",
          },
        }}
      />

      <div className="min-h-screen">
        <Cart />



          <div>

<PufframaBanner/>
          {/* <HeroSection/> */}
          <ShopByCategory/>
          <FeaturedBrands/>
                  <PopularProduct/>

          <CuratedCollections/>
     
        </div> 

        {/* <div className="bg-white">
          <div className="mx-auto max-w-screen-2xl px-3 py-5 sm:px-10">
            <div className="flex w-full">

              <div className="flex-shrink-0 xl:pr-6 lg:block w-full lg:w-3/5">
                <Slider />
              </div>

              <div className="hidden w-full lg:flex">
                <div className="group w-full">
                  <div className="h-full rounded border-2 border-orange-500 bg-gray-50 shadow transition duration-150 ease-linear transform group-hover:border-emerald-500">

                    <div className="flex items-center justify-center rounded-t border-b bg-orange-100 px-6 py-2 text-gray-900">
                      <h3 className="text-base font-normal">
                        Latest Super Discount Active Coupon Code
                      </h3>
                    </div>

                    <div className="flex items-center justify-center rounded-t border-b bg-green-100 px-6 py-2 text-gray-900">
                      <h3 className="text-base font-bold">
                        One Price, Double flavours
                      </h3>
                    </div>

                    <div className="overflow-hidden">
                      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-4">

                        {[1].map((item, i) => (
                          <div
                            key={i}
                            className="flex items-center overflow-hidden rounded-lg bg-white shadow-md"
                          >

                            <div className="w-1/2 p-4">
                              <img
                                src="https://api.pufframa.com/uploads/product-images/1752058618788-swft-pro-disposable-apple-peach-5-ApplePeach_72110339-bed3-4923-bc18-406f915225d0_600x.png"
                                alt="Product"
                                className="h-auto w-full object-contain"
                                crossOrigin="anonymous"
                              />
                            </div>

                            <div className="w-1/2 space-y-1 px-4 py-4">

                              <p className="text-sm font-semibold text-red-500">
                                41% Off
                              </p>

                              <p className="text-lg font-bold text-gray-800">
                                Swft Pro Disposable - Apple Peach 5%
                              </p>

                              <div className="flex items-center gap-3">

                                <span className="text-xl font-bold text-green-600">
                                  $12.99
                                </span>

                                <span className="text-sm text-gray-500 line-through">
                                  $21.99
                                </span>

                              </div>

                            </div>

                          </div>
                        ))}

                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>

            <OrganicProductCard />
          </div>
        </div> */}

        {/* <Categories />

        <PopularProduct />

        <FastDeliveryCard />

        <LatestDiscountedProduct /> */}
      </div>
    </div>
  );
}

export default Home;